import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8a63ab8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_4 = { class: "card-body p-25" }
const _hoisted_5 = { class: "row mb-4" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Période", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "all" }, "Toute la période", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "week" }, "Cette semaine", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "month" }, "Ce mois", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "year" }, "Cette année", -1))
const _hoisted_12 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Date de début", -1))
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Date de fin", -1))
const _hoisted_17 = { class: "table-responsive" }
const _hoisted_18 = { class: "table table-hover" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "table-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Document"),
    /*#__PURE__*/_createElementVNode("th", null, "Catégorie"),
    /*#__PURE__*/_createElementVNode("th", null, "Date téléchargement"),
    /*#__PURE__*/_createElementVNode("th", null, "Taille du fichier"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1))
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0 me-3" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "bg-primary rounded-circle p-2",
    style: {"width":"40px","height":"40px"}
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download text-white fs-16" })
  ])
], -1))
const _hoisted_22 = { class: "mb-0 fw-semibold" }
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = { class: "badge bg-secondary" }
const _hoisted_25 = { class: "fw-medium" }
const _hoisted_26 = { class: "text-muted" }
const _hoisted_27 = { class: "fw-medium" }
const _hoisted_28 = { class: "text-muted" }
const _hoisted_29 = { class: "d-flex gap-2" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download" }, null, -1))
const _hoisted_32 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_33 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download fs-1 text-muted" }, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-muted mt-3" }, "Aucun téléchargement trouvé", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Votre historique de téléchargements apparaîtra ici.", -1))
const _hoisted_37 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPeriod) = $event)),
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
              }, _hoisted_12, 544), [
                [_vModelSelect, _ctx.selectedPeriod]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startDate) = $event)),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
              }, null, 544), [
                [_vModelText, _ctx.startDate]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event)),
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
              }, null, 544), [
                [_vModelText, _ctx.endDate]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("table", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.telechargements, (telechargement) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: telechargement.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("div", null, [
                          _createElementVNode("h6", _hoisted_22, _toDisplayString(telechargement.document?.titre || 'Titre non disponible'), 1),
                          _createElementVNode("small", _hoisted_23, " Par " + _toDisplayString(telechargement.document?.auteur.nom || 'Auteur inconnu') + " " + _toDisplayString(telechargement.document?.auteur.prenoms || 'Auteur inconnu'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(telechargement.document?.categorie?.nom || 'Non définie'), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.formatDate(telechargement.createdAt)), 1),
                        _createElementVNode("small", _hoisted_26, "à " + _toDisplayString(_ctx.formatTime(telechargement.createdAt)), 1)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formatFileSize(telechargement.tailleFichier)), 1),
                        _createElementVNode("small", _hoisted_28, _toDisplayString(telechargement.document?.format || 'PDF'), 1)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-success",
                          onClick: ($event: any) => (_ctx.telechargerDocument(telechargement.document)),
                          title: "Télécharger"
                        }, [
                          _hoisted_31,
                          _createTextVNode(" Rétélécharger ")
                        ], 8, _hoisted_30)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_PaginationComponent, {
                page: _ctx.page,
                totalPages: _ctx.totalPages,
                totalElements: _ctx.totalElements,
                limit: _ctx.limit,
                onPaginate: _ctx.handlePaginate
              }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
            ]),
            (_ctx.telechargements.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_37))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}